export function getPrevRealBlock(blocks, i) {
  let block;
  let j = i;

  const setBlock = () => {
    j -= 1;
    block = blocks[j];
  };

  setBlock();

  while (block && block.type === 'SCROLL_TRACKING') {
    setBlock();
  }

  return block;
}
